/**
 * @param {object} consentConfig
 * @param {boolean} consentConfig.personalized_content
 * @param {boolean} consentConfig.running_targeted_advertising
 * @param {boolean} consentConfig.share_data_to_3rd_party
 *
 * @returns {string} expected to correspond to keys in the locale files
 */
export default function makeLocaleKey(consentConfig) {
  const {
    personalized_content: isPersonalized,
    running_targeted_advertising: isAdvertising,
    share_data_to_3rd_party: isSharing,
  } = consentConfig

  if ( isPersonalized ) {
    if ( isAdvertising ) {
      return ( isSharing ) ? 'personalizedContentAndAds' : 'personalizedContentAndAdsNoShare'
    }

    return ( isSharing ) ? 'personalizedContentAndShareData' : 'personalizedContent'
  }

  if ( isAdvertising ) {
    return ( isSharing ) ? 'personalizedAdsAndShareData' : 'personalizedAds'
  }

  return ( isSharing ) ? 'shareData' : 'defaultCopy'
}

